import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import apiClient from '../../../lib/axios';

interface EshopStatus {
  status: 'connected' | 'disconnected';
  merchant_id?: string;
  merchant_name?: Record<string, string>;
  external_user_id?: string;
  scopes?: string[];
  connected_at?: string;
}

interface InitiateResponse {
  authorize_url: string;
  state: string;
}

interface CallbackResponse {
  status: string;
  merchant_name?: string;
  merchant_key?: string;
}

export const ESHOP_STATUS_KEY = ['integrations', 'eshop', 'status'];

export function useEshopStatus() {
  return useQuery({
    queryKey: ESHOP_STATUS_KEY,
    queryFn: async () => {
      const { data } = await apiClient.get<EshopStatus>('/v1/integrations/eshop/status');
      return data;
    },
    staleTime: 30_000,
  });
}

export function useEshopInitiate() {
  return useMutation({
    mutationFn: async (params?: { lang?: string }) => {
      const { data } = await apiClient.post<InitiateResponse>('/v1/integrations/eshop/initiate', params);
      return data;
    },
  });
}

export function useEshopCallback() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: { code: string; state: string }) => {
      const { data } = await apiClient.post<CallbackResponse>('/v1/integrations/eshop/callback', params);
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ESHOP_STATUS_KEY });
    },
  });
}

export function useEshopDisconnect() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const { data } = await apiClient.delete('/v1/integrations/eshop/disconnect');
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ESHOP_STATUS_KEY });
    },
  });
}
